import React from "react";
import { Page } from "@version2/domain-package";
import { Button } from "@version2/ui-package";
import { Col } from "@version2/ui-package";

type FooterButtonProps = {
	page?: Page;
	text?: string;
	isExternal?: boolean;
	onClick?: () => void;
};

const FooterButton = ({
	page,
	text,
	isExternal,
	onClick,
}: FooterButtonProps) => {
	return (
		<Col>
			<Button
				href={page?.url}
				type="text"
				onClick={onClick}
				isExternal={isExternal}
			>
				{text || page?.name}
			</Button>
		</Col>
	);
};

export default FooterButton;
